import { desktopFinanceForexPageAdsBuilder } from "./desktopFinanceForexPageAdsBuilder";
import { mobileFinanceForexPageAdsBuilder } from "./mobileFinanceForexPageAdsBuilder";
import { deviceUtil, pageUtil } from "@repo/lib-common";
import { DomainPageClient } from "@repo/lib-domain-tag";
let isPageClientInitiated = false;
const PageTypeEnum = pageUtil.PageTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-var
declare var pbjs: any;
export const initPageClient_FinanceIndex = function () {
    if (isPageClientInitiated) return;
    isPageClientInitiated = true;
    const device = window.domainDevice || new deviceUtil.DeviceTypeInfo();
    const pageClient = new DomainPageClient();
    pageClient.device = device;
    pageClient.pageType = PageTypeEnum.financeForex;


    if (device.isMobile()) {
        pageClient.adsBuilder = mobileFinanceForexPageAdsBuilder.setAdsConfAndApply(window.domainAdsConfForMobile);
    } else {
        pageClient.adsBuilder = desktopFinanceForexPageAdsBuilder.setAdsConfAndApply(window.domainAdsConfForDesktop);
    }

    window.domainClient = pageClient;
    const isLoggedIn = pageClient.doesCookieExists('loggedIn') && pageClient.doesCookieExists('_sgf_facebook_name') && pageClient.doesCookieExists('_sgf_user_pids');
    pageClient.adsBuilder.setIsEnabled(!isLoggedIn);
    pageClient.adsBuilder.executeAsPbjsCommand(() => {
        pbjs.enableAnalytics({
            provider: 'yandex',
            options: {
                counters: [48985463],
            },
        });
    }
    );
    pageClient.adsBuilder.execute();
}
initPageClient_FinanceIndex();
